const shuffleArrayOnce = <T>(array: T[]): T[] => {
  let currentIndex = array.length;
  while (0 !== currentIndex) {
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex]
    ];
  }

  return array;
};

const shuffleArray = <T>(array: T[]): T[] => {
  let shuffledArray = array;
  do {
    shuffledArray = shuffleArrayOnce(shuffledArray);
  } while (JSON.stringify(array) !== JSON.stringify(shuffledArray));

  return shuffledArray;
};

export default shuffleArray;
